import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const NetworkErrorScreen = () => (
   <>
      <HelmetProvider>
          <Helmet>
             <title>Network Error</title>
          </Helmet>
      </HelmetProvider>
      <div className="container">
         <h1 className="mt-4">Network Error</h1>
         <p>Check your internet connection and reload this page.</p>
         <button
            className="btn btn-primary"
            type="button"
            onClick={() => window.location.reload()}
         >
            Try Again
         </button>
      </div>
   </>
);

export { NetworkErrorScreen };
